import { useCallback } from "react"
import { createModel } from "hox"
import { useSetState } from "ahooks-v2"
import { poiTagIds } from "@/constants/constant"
import type { CrowdTagVO } from "@/api"
// ==============================================
interface IUseTagsState {
  /**
   * 周边生态：添加更多类别
   */
  selectedTags: any[]
  selectedColors?: Map<any, any>
  isTagsShow: boolean // 类别是否全部显隐
  /**
   * 场景拓客-企业：所属行业
   */
  isIndustryShow: boolean // 所属行业弹窗是否显示
  industryRange: string[] // 所属行业取值范围
  industrySelectedNames: {
    industryL1Name: string[] // 一级行业name筛选
    industryL2Name: string[] // 二级行业name筛选
    industryL3Name: string[] // 三级行业name筛选
  }
  industrySelectedCodes: string[]
  /**
   * 场景拓客-政府：分类
   */
  isOrganShow: boolean
  organData?: any[]
  organSelectedCodes: string[]
  /**
   * 智能选址-设置选址逻辑-目标人群特征
   */
  crowdTags: CrowdTagVO[]
}

function useTags() {
  const [state, set] = useSetState<IUseTagsState>({
    selectedTags: poiTagIds, // 默认显示 办公地点, 住宿
    isTagsShow: true,
    isIndustryShow: false,
    industryRange: [],
    industrySelectedNames: {
      industryL1Name: [],
      industryL2Name: [],
      industryL3Name: [],
    },
    industrySelectedCodes: [],
    isOrganShow: false,
    organSelectedCodes: ["all"],
    crowdTags: [],
  })

  const setAllState = useCallback(
    (value: Partial<IUseTagsState> | ((prevState: IUseTagsState) => Partial<IUseTagsState>)) => {
      set(value)
    },
    [set],
  )

  return { ...state, setAllState }
}

export default createModel(useTags)
